import React from 'react';

const Peoples: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M9.38184 11.5049C10.4528 11.5581 11.4687 12.0077 12.2305
      12.7695C13.043 13.5821 13.4999 14.6839 13.5 15.833V17.5C13.5
      18.0523 13.0523 18.5 12.5 18.5C11.9477 18.5 11.5 18.0523 11.5
      17.5V15.833C11.4999 15.2143 11.2539 14.6211 10.8164 14.1836C10.4336
      13.8008 9.93154 13.5648 9.39746 13.5117L9.16699 13.5H5.83301C5.21429
      13.5001 4.6211 13.7461 4.18359 14.1836C3.74609 14.6211 3.50009 15.2143
      3.5 15.833V17.5C3.5 18.0523 3.05228 18.5 2.5 18.5C1.94772 18.5 1.5
      18.0523 1.5 17.5V15.833C1.50009 14.6839 1.95695 13.5821 2.76953
      12.7695C3.58211 11.957 4.68385 11.5001 5.83301 11.5H9.16699L9.38184
      11.5049ZM14.0322 12.375C14.1617 11.8739 14.6485 11.5595 15.1494
      11.6357L15.25 11.6572L15.5918 11.7607C16.3774 12.0343 17.0706 12.5293
      17.585 13.1895C18.1726 13.9437 18.4944 14.871 18.5 15.8271V17.5C18.5
      18.0522 18.0523 18.5 17.5 18.5C16.9477 18.5 16.5 18.0522 16.5
      17.5V15.8389L16.4912 15.6465C16.4517 15.2005 16.2837 14.7733 16.0068
      14.418C15.73 14.0629 15.3572 13.7967 14.9346 13.6494L14.75
      13.5928L14.6523 13.5625C14.1769 13.3869 13.9028 12.8763 14.0322
      12.375ZM7.71484 1.50488C8.7859 1.558 9.80257 2.00765 10.5645
      2.76953C11.3768 3.58208 11.8339 4.68401 11.834 5.83301L11.8281
      6.04785C11.7751 7.11894 11.3263 8.13553 10.5645 8.89746C9.80258
      9.65933 8.78589 10.108 7.71484 10.1611L7.5 10.167C6.351 10.1669
      5.24907 9.70984 4.43652 8.89746C3.67457 8.13551 3.22492 7.11902
      3.17188 6.04785L3.16699 5.83301C3.16708 4.68385 3.62394 3.5821
      4.43652 2.76953C5.24909 1.95705 6.35092 1.50009 7.5 1.5L7.71484
      1.50488ZM12.3643 2.36035C12.4926 1.85896 12.9795 1.54399 13.4805
      1.61914L13.5811 1.63965L13.9258 1.74316C14.7163 2.01722 15.4135
      2.51572 15.9297 3.18066C16.5195 3.94069 16.8398 4.87583 16.8398
      5.83789L16.8242 6.19727C16.7547 7.03093 16.4458 7.83023 15.9297
      8.49512C15.3397 9.25497 14.513 9.79653 13.5811 10.0352C13.0462
      10.1719 12.5012 9.84932 12.3643 9.31445C12.2275 8.77964 12.5502
      8.23476 13.085 8.09766C13.5867 7.96917 14.032 7.67764 14.3496
      7.26855C14.6275 6.91057 14.7936 6.48011 14.8311 6.03125L14.8398
      5.83789C14.8398 5.31993 14.6671 4.81644 14.3496 4.40723C14.0717
      4.04917 13.6962 3.78037 13.2705 3.63281L13.085 3.57715L12.9873
      3.54688C12.5117 3.37218 12.236 2.86182 12.3643 2.36035ZM7.5
      3.5C6.88136 3.50009 6.28808 3.74619 5.85059 4.18359C5.41308 4.6211
      5.16708 5.21429 5.16699 5.83301L5.17871 6.06348C5.23167 6.59778
      5.4676 7.10041 5.85059 7.4834C6.28806 7.9207 6.88143 8.16691 7.5
      8.16699L7.73047 8.15527C8.26468 8.10227 8.76747 7.86632 9.15039
      7.4834C9.58787 7.04583 9.83398 6.45177 9.83398 5.83301L9.82227
      5.60254C9.76921 5.0686 9.53304 4.5664 9.15039 4.18359C8.76748 3.80068
      8.26467 3.56473 7.73047 3.51172L7.5 3.5Z`} fill="#98A2B3"/>
  </svg>
);

export default Peoples;
